import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as viewReducer from "containers/View/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";

import DatasetSearch from "components/View/DatasetSearch";

class DatasetSearchContainer extends React.Component {
  render() {
    return <DatasetSearch {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateViewField: (id, field) => dispatch(galleryReducer.updateViewField(id, field))
});

const mapStateToProps = (state, ownProps) => {
  return {
    search: viewReducer.getSearch(state),

    datasets: viewReducer.getDatasetSearchResult(state),
    reports: viewReducer.getReports(state),
    isDatasetSearching: viewReducer.getIsDatasetSearching(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(DatasetSearchContainer);
